<template>
    <home-page></home-page>
</template>

<script>

    import HomePage from '@/HomePage/HomePage.vue';

    export default {
        name: 'HomeLayout',
        components: {
            'home-page': HomePage
        }
    }
</script>


// WEBPACK FOOTER //
// HomeLayout.vue?734ade36